import React, { Fragment } from 'react'

export const totalLandArea = `
  The appraisal is based upon an industrial development, and the area represents
  the Gross Internal Area (GIA) of the building/buildings. An office development
  would be based upon a Net Internal Area (NIA) – typically 85% of the GIA.
`

export const netLandArea = undefined
export const rentValue = undefined

export const initialYield = `
  This is the yield used to capitalise the ‘Passing Rent’. Most National
  Chartered Surveying practices regularly release ‘Investment Yield Guides’ from
  which applicable yields can be obtained.
`

export const purchasersCosts = (
  <Fragment>
    These are the costs that an end purchaser will incur in buying the scheme
    once let, as an investment. This is based upon the prevailing ‘Stamp Duty
    Land Tax’, with an addition 1.8% which covers agents fees, legal acquisition
    fees and survey costs. To obtain the ‘base’ stamp duty cost consider
    {' '}
    <a href='https://www.gov.uk/stamp-duty-land-tax' target='_blank' rel='noopener noreferrer'>
      www.gov.uk/stamp-duty-land-tax
    </a>.<br />
    Should the scenario be that the developer retains the scheme once the scheme
    is fully occupied/let then ‘Purchasers Costs’ are not applicable.
  </Fragment>
)

export const baseBuildCost = (
  <Fragment>
    This covers the construction of the buildings, but not the wider site works.
    Currently the build cost for Light Industrial (B1) will be c.£60 sq ft and
    General Industrial £70-£80 sq. B8 (Distribution) will be c.£55 ft. Office
    build costs are c.£130-£160 sq ft, dependent upon specification.<br />
    Please note that build costs relate to the totality of the buildings, namely
    the Gross Area.
  </Fragment>
)

export const developmentContingency = `
  This is a percentage of the base build cost and is typically 3-5% and covers
  delays, cost over run or issues arising that had not been planned.
`
export const externals = `
  This is the sum of the ‘non-build’ site works and could include site
  clearance, site roads and landscaping, with 10% of the ‘Base Build Cost’ being
  appropriate for an industrial development. Should a site have significant
  delivery costs (extensive clearance or remediation) then this figure could
  increase to 15-20%.
`
export const professionalFees = `
  Accounts for all the fees paid to professionals during the conception and
  delivery of the scheme. This covers input by Architects, Quantity Surveyors,
  Civil & Structural Engineers, and Project Managers. Expressed as a percentage
  of the ‘Total Build Cost’, this is typically 10% of the ‘Total Build Cost’.
`
export const lettingAgentFees = `
  Covers the fees of the agent marketing the space across the scheme and
  negotiating tenancies.
`
export const legalLettingFees = `
  Legal fees associated with the completion of tenancies.
`
export const salesAgentFees = `
  Agents fee for marketing the completed scheme as an investment and securing a
  purchaser. (Should the scenario be that the developer retains the scheme once
  the scheme is fully occupied then these costs are not applicable).
`
export const legalSalesFees = `
  Legal Fee for completion of legal documentation associated with the sale of
  the completed scheme. (Should the scenario be that the developer retains the
  scheme once the scheme is fully occupied then these costs are not applicable).
`
export const finance = `
  Cost of the development finance for delivering the scheme. The percentage
  reflects prevailing economic conditions.
`

export const profit = `
  For a commercial development scheme profit is based upon the ‘Total Build
  Cost’. Currently a standard profit target for a commercial developer is 15%,
  but this could be lower c.10%-12% if the developer had secured a pre let
  tenant or design and build contract.
`
export const legalSiteAcquisitionCost = `
  Legal cost for acquiring the land. There is no set fee level for such. In
  terms of assumptions schemes of up to 3 Acres Say £20,000, schemes of 5-10
  Acres say £30,000 and schemes in excess of 10 Acres say £40,000.
`
export const planning = `
  This cost relates to the preparation and submission of the planning
  application.
`
export const surveys = `
  This cost includes topographical surveys, ground investigations, asbestos
  surveys, ecology surveys, drainage, highways etc.
`

export const stampDuty = (
  <Fragment>
    Incorporating a Stamp Duty calculation within such a basic appraisal adds
    unnecessary complexity. Consequently parties need to be aware that this is
    additional cost and the cost can be obtained by utilising the calculator
    within
    {' '}
    <a href='https://www.gov.uk/stamp-duty-land-tax' target='_blank' rel='noopener noreferrer'>
      www.gov.uk/stamp-duty-land-tax
    </a>.<br />
    Please note that for housing sites the basis should be commercial property
    not residential.
  </Fragment>
)

export const toolDisclaimer = `
  Outputs related to this ‘Residual Development Appraisal Tool’ are indicative
  only and should not be relied upon for valuation purposes. Outputs do not
  represent valuations under the RICS ‘Red Book’.
`

export const landValue = `
  For the assumptions of this ‘basic appraisal’, this is the residue once the
  total costs (including profit and acquisition costs) are subtracted from the
  Gross Development Value (GDV).
`
